<template>
  <div>
    <calendar class="card card-body rounded-top" :events="events" @eventClick="showEventModal" />

    <event-modal :event="selectedEvent" :id="idToEdit" :show="showModal" @close="hideModal" @updated="refreshEvents" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import EventModal from '@/components/modals/EventModal';
import { calendarMixin } from '@/mixins/calendar';
import { beforeCalendarRoute } from '@/routesUtils/calendar';
import { TableName } from '../../enums/tableName.enum';

// @vuese
// Kalendarz z wydarzeniami profilu
// @group Profile
export default {
  components: { EventModal },
  mixins: [calendarMixin],
  computed: mapState({
    profileId: state => state.profile.data.id
  }),
  beforeRouteUpdate(to, from, next) {
    beforeCalendarRoute(to, this.profileId, TableName.User, next);
  }
};
</script>
